var React = require('react');

function CheckCir (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18 13.968 13.968 18 9 18C4.032 18 0 13.968 0 9ZM12.9994 4.48987L14.9777 6.58328L7.04698 15.0101L2.51758 10.2172L4.50603 8.1279L7.04607 10.8157L12.9994 4.48987Z","fill":"#C4C4C4"}));
}

CheckCir.defaultProps = {"viewBox":"0 0 18 18","fill":"none"};

module.exports = CheckCir;

CheckCir.default = CheckCir;
